import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const StyledIframe = styled.iframe`
  position: absolute;
  max-width: 700px;
  width: calc(100% - 60px);
  height: calc(100% - 60px);
  background: #fff;
  border: 0;
  box-shadow: 0px 3px 6px #00000029;
`;

export const PreviewButtons = styled.div`
  margin-top: 30px;

  ${media.md`
    display: flex;
    flex-direction: row;
  `}

  button {
    width: 100%;
    margin-bottom: 10px;

    ${media.md`
      width: initial;
      margin-right: 10px;
    `}
  }
`;
